import { ReactNode } from 'react';
import { EmptyStateConnectedEmail } from '../empty-state/empty-state-connected-email';
import { EmptyStateDisconnectedEmail } from '../empty-state/empty-state-disconnected-email';
import { TabValue } from '../invoices-section-tabs/invoices-section-tabs';

type InvoiceTabContentWrapperProps = {
  variant: TabValue;
  tabInvoiceCount: number;
  hasInvoiceData: boolean;
  isEmailConnected: boolean;
  onConnectGmail: () => void;
  children: ReactNode;
};

export const InvoiceTabContentWrapper = ({
  variant,
  tabInvoiceCount,
  hasInvoiceData,
  isEmailConnected,
  onConnectGmail,
  children,
}: InvoiceTabContentWrapperProps) => {
  if (tabInvoiceCount > 0) {
    return children;
  }

  if (isEmailConnected || hasInvoiceData) {
    return <EmptyStateConnectedEmail variant={variant} />;
  }

  return <EmptyStateDisconnectedEmail onConnectGmail={onConnectGmail} />;
};
